/**
 * Shared language constants for the entire app.
 *
 * Single source of truth — used by ProfileSettings, Forms, HistorySettings,
 * CampaignTypes, and any future language selector.
 *
 * Includes all languages supported by the Grok Voice Agent + CLD3 detection.
 * Sorted: English first, then alphabetical by display name.
 */

const SUPPORTED_LANGUAGES = [
  { value: "en", name: "English" },
  { value: "am", name: "Amharic" },
  { value: "ar", name: "Arabic" },
  { value: "bn", name: "Bengali" },
  { value: "my", name: "Burmese" },
  { value: "yue", name: "Cantonese Chinese" },
  { value: "hr", name: "Croatian" },
  { value: "cs", name: "Czech" },
  { value: "nl", name: "Dutch" },
  { value: "fr", name: "French" },
  { value: "de", name: "German" },
  { value: "el", name: "Greek" },
  { value: "gu", name: "Gujarati" },
  { value: "ht", name: "Haitian Creole" },
  { value: "he", name: "Hebrew" },
  { value: "hi", name: "Hindi" },
  { value: "hu", name: "Hungarian" },
  { value: "id", name: "Indonesian" },
  { value: "it", name: "Italian" },
  { value: "ja", name: "Japanese" },
  { value: "ko", name: "Korean" },
  { value: "zh", name: "Mandarin Chinese" },
  { value: "ne", name: "Nepali" },
  { value: "no", name: "Norwegian" },
  { value: "fa", name: "Persian" },
  { value: "pl", name: "Polish" },
  { value: "pt", name: "Portuguese" },
  { value: "pa", name: "Punjabi" },
  { value: "ro", name: "Romanian" },
  { value: "ru", name: "Russian" },
  { value: "sr", name: "Serbian" },
  { value: "es", name: "Spanish" },
  { value: "sw", name: "Swahili" },
  { value: "sv", name: "Swedish" },
  { value: "tl", name: "Tagalog" },
  { value: "ta", name: "Tamil" },
  { value: "te", name: "Telugu" },
  { value: "th", name: "Thai" },
  { value: "tr", name: "Turkish" },
  { value: "uk", name: "Ukrainian" },
  { value: "ur", name: "Urdu" },
  { value: "vi", name: "Vietnamese" },
];

/**
 * Just the ISO 639-1 codes (for validation).
 */
const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(l => l.value);

/**
 * Render <option> elements for a <Select> dropdown.
 * Usage: <Select>{languageOptions()}</Select>
 */
function languageOptions() {
  // Returns raw data; React components should map over SUPPORTED_LANGUAGES directly
  return SUPPORTED_LANGUAGES;
}

export { SUPPORTED_LANGUAGES, SUPPORTED_LANGUAGE_CODES, languageOptions };
export default SUPPORTED_LANGUAGES;
